import * as errorTypes from '../../constants/errorStatuses';

const DEFAULT = 'DEFAULT_EXCEPTION';

function toErrorKey(status) {
  // this table defines static error messages (see spec) that need to work offline
  switch (status) {
    // payment cancel
    case errorTypes.PAYMENT_CANCEL:
      return 'WIRECARD_CANCEL';
    // // Payment Fehler von Payment
    case errorTypes.PAYMENT_EXPIRED:
    case errorTypes.PAYMENT_PENDING:
    case errorTypes.PAYMENT_UNAUTHORIZED:
    case errorTypes.PAYMENT_FAIL:
      return 'WIRECARD_FAIL';
    // Timeout des Logins (sowohl manuelles Login als auch per Depplink mit Token)
    // ODER Fehlende Zugriffsrechte (primär wenn Seiten z.B. per Back-Button nach Logout aufgerufen werden)
    case errorTypes.FORBIDDEN:
      return 'ERROR_FORBIDDEN';
    // Seite kann nicht geladen werden (vermutlich alter Bookmark, möglicherweise Fehler beim Deployment)
    case errorTypes.NOT_FOUND:
      return 'ERROR_NOTFOUND';
    // Fehler der API
    case errorTypes.SERVER_ERROR:
      return 'SERVER_ERROR';
    // Timeout der API (langsame Verbindung)
    case errorTypes.TIMEOUT:
      return 'TIMEOUT_ERROR';
    // Fehler der UI - javascript error
    case errorTypes.EXCEPTION:
      return DEFAULT;
    // andere Fehler
    default:
      return DEFAULT;
  }
}

export default toErrorKey;
